import { Component, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-iti-help',
  templateUrl: './iti-help.component.html',
  styleUrls: ['./iti-help.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ItiHelpComponent implements OnInit {

  constructor() { }

  ngOnInit() {/* empty */}

}
